import {
  ApiBlobGetRequest,
  ApiGetRequest,
  ApiPostRequest,
  //   ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Retur Beli',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Retur Beli',
        href: '/adm/logistic/retur-beli/retur-pembelian',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_retur_beli',
    sortDesc: true,
    fields: [
      {
        key: 'code_retur_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'tgl_retur_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },

      {
        key: 'status_retur_beli',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_retur_beli',
        label: 'Kode',
      },
      {
        key: 'supplier',
        label: 'Supplier',
      },
      {
        key: 'tgl_beli',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_buy',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
    ],
    journal: false,
    row_item: {
      description: '',
      id_product: '',
      item_acc: '',
      item_retur: '',
      item_send: '',
      id_satuan: '',
      item_price: '',
      item_disc: '',
      item_disc_nominal: '',
      item_acc_disc: '',
      item_id_pajak: '',
      item_acc_tax: '',
      item_tax: '',
      item_persentase: 0,
      item_total: 0,
    },
    form: {
      code_beli: '',
      id_supplier: '',
      supplier_code: '',
      supplier_name: '',
      tgl_beli: '',
      tgl_faktur: '',
      tgl_kirim: '',
      id_currency: '',
      id_department: '',
      id_gudang: '',
      type_buy: true,
      type_payment: false,
      remark: '',
      term_payment: '',
      memo: '',
      other_cost: '',
      acc_other_cost: '',
      acc_other_cost_code: '',
      acc_other_cost_name: '',
      total_pajak: '',
      total_invoice: '',
      down_payment: '',
      id_um_beli: '',
      total_payment: '',
      acc_total_payment: '',
      acc_total_payment_code: '',
      acc_total_payment_name: '',
      status_beli: '',
      id_journal: '',
      id_sales: '',
      sales_code: '',
      sales_name: '',
      items: [],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeReturBeli(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        code_beli: '',
        id_supplier: '',
        supplier_code: '',
        supplier_name: '',
        tgl_beli: '',
        tgl_faktur: '',
        tgl_kirim: '',
        id_currency: '',
        id_department: '',
        id_gudang: '',
        type_buy: true,
        type_payment: false,
        remark: '',
        term_payment: '',
        memo: '',
        other_cost: '',
        acc_other_cost: '',
        acc_other_cost_code: '',
        acc_other_cost_name: '',
        total_pajak: '',
        total_invoice: '',
        down_payment: '',
        id_um_beli: '',
        total_payment: '',
        acc_total_payment: '',
        acc_total_payment_code: '',
        acc_total_payment_name: '',
        status_beli: '',
        id_journal: '',
        id_sales: '',
        sales_code: '',
        sales_name: '',
        items: [],
      },
    });
  },
};

export const actions = {
  async getDetailPembelian({ commit, state }, payload = null) {
    commit('changeReturBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/pembelian/${payload.id}`);
    commit('changeReturBeli', {
      loading: false,
    });

    if (!result.error) {
      let detail = result.data.object;
      detail.items.map((item, index) => {
        detail.items[index].item_total = 0;
        detail.items[index].item_retur = 0;
        detail.items[index].item_tax = 0;
      });

      detail.total_invoice = 0;
      detail.total_pajak = 0;

      commit('changeReturBeli', {
        detail: detail,
        form: {
          ...data.form,
          ...detail,
          type_buy: detail.type_buy && parseInt(detail.type_buy) > 0 ? 1 : 0,
          type_payment:
            detail.type_payment && parseInt(detail.type_payment) > 0 ? 1 : 0,
        },
      });
    }

    return !result.error ? true : false;
  },

  async getLastNoFaktur({ commit, state }) {
    commit('changeReturBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/retur-beli/last-id`);
    commit('changeReturBeli', {
      form: {
        ...data.form,
        code_retur: result.data.object,
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListReturBeli({ commit, state }, payload = null) {
    commit('changeReturBeli', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      retur: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`logistic/retur-beli`, params);
      commit('changeReturBeli', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_retur_beli.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`logistic/retur-beli`, params);
      commit('changeReturBeli', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getJournalInvoice({ commit }, payload = null) {
    commit('changeReturBeli', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `logistic/retur-beli/${payload.id}/journal`
    );
    commit('changeReturBeli', {
      loading: false,
    });

    if (!result.error) {
      commit('changeReturBeli', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailReturBeli({ commit, state }, payload = null) {
    commit('changeReturBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/retur-beli/${payload.id}`);
    commit('changeReturBeli', {
      loading: false,
    });

    if (!result.error) {
      commit('changeReturBeli', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          tgl_retur_beli: result.data.object.tgl_retur_beli
            ? moment(result.data.object.tgl_retur_beli).format('DD/MM/YYYY')
            : '',
          type_buy:
            result.data.object.type_buy &&
            parseInt(result.data.object.type_buy) > 0
              ? 1
              : 0,
          type_payment:
            result.data.object.type_payment &&
            parseInt(result.data.object.type_payment) > 0
              ? 1
              : 0,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createReturBeli({ commit, state, dispatch }) {
    commit('changeReturBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('logistic/retur-beli', data.form);

    commit('changeReturBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateReturBeli({ commit, state, dispatch }, payload = null) {
    commit('changeReturBeli', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `logistic/retur-beli/${payload.id}`,
      data.form
    );

    commit('changeReturBeli', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
